import React from "react";
import styled from "styled-components";
import { Delete } from "../../assets/icons";
import { Colors } from "../../ColorConstants";
import ProductCounter from "./ProductCounter";

const getTime = (timeString) => {
  const startTimeStr = timeString.slice(0, 4);
  const endTimeStr = timeString.slice(5);

  let startHour = parseInt(startTimeStr.slice(0, 2));
  let endHour = parseInt(endTimeStr.slice(0, 2));
  const startMinute = parseInt(startTimeStr.slice(2));
  const endMinute = parseInt(endTimeStr.slice(2));

  let startSuffix = "AM";
  if (startHour >= 12) {
    startSuffix = "PM";
    if (startHour > 12) {
      startHour -= 12;
    }
  }

  let endSuffix = "AM";
  if (endHour >= 12) {
    endSuffix = "PM";
    if (endHour > 12) {
      endHour -= 12;
    }
  }

  const formattedStartTime = `${startHour
    .toString()
    .padStart(2, "0")}:${startMinute
    .toString()
    .padStart(2, "0")} ${startSuffix}`;
  const formattedEndTime = `${endHour.toString().padStart(2, "0")}:${endMinute
    .toString()
    .padStart(2, "0")} ${endSuffix}`;
  return `${formattedStartTime} - ${formattedEndTime}`;
};

const CartProducts = ({ item, onDelete, onSubtract, onAdd }) => {
  return (
    <AddedProductsContainer>
      <ProductValues>{item.name}</ProductValues>
      <ProductValues>{item.unitPrice}</ProductValues>
      <ProductValues>
        <ProductCounter
          onSubtract={() => onSubtract(item._id)}
          onAdd={() => onAdd(item._id)}
          count={item.qty}
        />
      </ProductValues>
      <ProductValues>{item.totalPrice}</ProductValues>
      <DeleteImage src={Delete} onClick={() => onDelete(item._id)} />
    </AddedProductsContainer>
  );
};

export const AquaCartProducts = ({ item, onDelete }) => {
  return (
    <AquaMainProductContainer>
      <AquaAddedProductsContainer>
        <ProductValues align="left">{item?.name}</ProductValues>
        <ProductValues>{""}</ProductValues>
        <ProductValues>{""}</ProductValues>
        {/* <ProductValues>{''}</ProductValues> */}
        <ProductValues>QAR {item?.totalPrice}</ProductValues>
        <DeleteImage src={Delete} onClick={() => onDelete(item?._id)} />
      </AquaAddedProductsContainer>
      {item.slots.map((slot, index) => (
        <AquaSubAddedProductsContainer>
          <ProductSubValues align="left">
            {`Unit ${Number(index + 1)} - ${slot.aquaDuration} min`}
          </ProductSubValues>
          <ProductSubValues align="center">
            {getTime(slot.slot)}
          </ProductSubValues>
          <ProductSubValues align="center">
            QAR {slot.unitPrice}
          </ProductSubValues>
          <ProductSubValues align="center"></ProductSubValues>
          <DeleteImage
            src={Delete}
            onClick={() => onDelete(item?._id)}
            hidden
          />
        </AquaSubAddedProductsContainer>
      ))}
    </AquaMainProductContainer>
  );
};

const AquaMainProductContainer = styled.div`
  border-bottom: 1px solid ${Colors.lightBlack};
  padding: 2rem 0;
`;
const AquaSubAddedProductsContainer = styled.div`
  // padding-left: 3rem;
  display: flex;
  flex-direction: row;
  gap: 3.5rem;
  justify-content: flex-start;
  align-items: center;
  text-align: left;
  @media only screen and (max-width: 1024px) {
    gap: 3rem;
  }
  @media only screen and (max-width: 640px) {
    gap: 0.5rem;
    overflow-x: scroll;
    padding: 0rem;
    width: 100%;
  }
`;

const AquaAddedProductsContainer = styled.div`
  padding: 1rem 0rem 1rem 0rem;

  display: flex;
  flex-direction: row;
  gap: 3.5rem;
  justify-content: flex-start;
  align-items: center;
  @media only screen and (max-width: 1024px) {
    gap: 3rem;
  }
  @media only screen and (max-width: 640px) {
    gap: 0.5rem;
    overflow-x: scroll;
    padding: 0rem;
    width: 100%;
  }
`;

const AddedProductsContainer = styled.div`
  padding: 3rem 0rem 3rem 0rem;
  display: flex;
  flex-direction: row;
  gap: 3.5rem;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid ${Colors.lightBlack};
  @media only screen and (max-width: 1024px) {
    gap: 3rem;
  }
  @media only screen and (max-width: 640px) {
    gap: 0.5rem;
    overflow-x: scroll;
    padding: 0rem;
    width: 100%;
  }
`;
const ProductValues = styled.span`
  color: ${Colors.arsenic};
  font-size: 1rem;
  font-weight: 700;
  width: 18%;
  text-align: ${(props) => props.align || "center"};
  @media only screen and (max-width: 640px) {
    padding: 1rem;
    width: 27%;
    font-size: 0.8rem;
  }
`;

const ProductSubValues = styled.span`
  color: ${Colors.arsenic};
  font-size: 1rem;
  font-weight: 500;
  width: 18%;
  text-align: ${(props) => props.align};
  @media only screen and (max-width: 640px) {
    padding: 1rem;
    width: 27%;
    font-size: 0.8rem;
  }
`;

const DeleteImage = styled.img`
  width: 1rem;
  height: 1.2rem;
  cursor: pointer;
  
`;

export default CartProducts;
